const BASE_URL = "/";
const OPTIONAL_PROJECT_ID_URL = ":projectId?";

declare const ANALYZER_URL: string;

export const MANAGER_URL = `${BASE_URL}manager`;
export const MANAGER_URL_WITH_PROJECT_ID = `${MANAGER_URL}/projekte/:projectId`;
export const MANAGER_URL_WITH_SITE_ID = `${MANAGER_URL_WITH_PROJECT_ID}/liegenschaften/:siteId`;

export const ROUTES = {
  productSelectPage: BASE_URL,
  analyzer: `${ANALYZER_URL}/analyzer/projekte`,

  startPage: `${MANAGER_URL}/startseite`,
  dashboard: `${MANAGER_URL}/projekte`,
  vermarktung: {
    entry: `${MANAGER_URL}/vermarktung`,
    entryWithProject: `${MANAGER_URL_WITH_PROJECT_ID}/vermarktung`,
    contract: `${MANAGER_URL}/vermarktung/:contractId`
  },
  project: {
    entry: MANAGER_URL_WITH_PROJECT_ID,
    sites: `${MANAGER_URL_WITH_PROJECT_ID}/liegenschaften`,
    companies: `${MANAGER_URL_WITH_PROJECT_ID}/unternehmen`,
    companiesWithId: `${MANAGER_URL_WITH_PROJECT_ID}/unternehmen/:companyId`,
    generators: `${MANAGER_URL_WITH_PROJECT_ID}/erzeuger`,
    permissions: `${MANAGER_URL_WITH_PROJECT_ID}/rechte`,
    settings: `${MANAGER_URL_WITH_PROJECT_ID}/einstellungen`,
    service: `${MANAGER_URL_WITH_PROJECT_ID}/service`,
    siteSetupAssistant: `${MANAGER_URL_WITH_PROJECT_ID}/liegenschaftskonfigurator/:siteSetupProcessId`
  },
  site: {
    entry: `${MANAGER_URL_WITH_SITE_ID}`,
    siteWithoutProject: `${MANAGER_URL}/liegenschaften/:siteId`,
    generators: `${MANAGER_URL_WITH_SITE_ID}/erzeuger`,
    generator: `${MANAGER_URL_WITH_SITE_ID}/erzeuger/:componentId`,
    generatorEditVerklammerung: `${MANAGER_URL_WITH_SITE_ID}/erzeuger/:componentId/anlage-stromstg-aendern`
  },
  todos: {
    entry: `${MANAGER_URL_WITH_PROJECT_ID}/aufgaben`
  },
  onboarding: {
    entry: `${MANAGER_URL_WITH_PROJECT_ID}/onboarding`,
    singleTodo: `${MANAGER_URL_WITH_PROJECT_ID}/onboarding/:todoId`
  },
  energyData: {
    entry: `${MANAGER_URL_WITH_PROJECT_ID}/energiedaten`
  },
  paragraph6: {
    entry: `${MANAGER_URL_WITH_PROJECT_ID}/paragraph6`
  },
  mieterstrom: {
    entry: `${MANAGER_URL_WITH_PROJECT_ID}/lieferungen-uebersicht`,
    contracts: `${MANAGER_URL_WITH_PROJECT_ID}/lieferungen-uebersicht/vertraege`,
    invoices: `${MANAGER_URL_WITH_PROJECT_ID}/lieferungen-uebersicht/rechnungen`,
    billingPlans: `${MANAGER_URL_WITH_PROJECT_ID}/lieferungen-uebersicht/abschlaege`
  },
  guaranteeOfOrigin: `${MANAGER_URL_WITH_PROJECT_ID}/herkunftsnachweis`,
  revenueMonitoring: {
    entry: `${MANAGER_URL}/erloesmonitoring`,
    entryWithProject: `${MANAGER_URL_WITH_PROJECT_ID}/erloesmonitoring`
  },
  ppa: `${MANAGER_URL}/ppa-abrechnung`,
  apiSettings: `${BASE_URL}api-einstellungen/${OPTIONAL_PROJECT_ID_URL}`,

  admin: `${BASE_URL}admin`,
  universalTodos: `${BASE_URL}admin-dashboard/aufgaben`,

  settings: `${BASE_URL}einstellungen`,

  siteComponentPage: `${MANAGER_URL_WITH_PROJECT_ID}/liegenschaften/:siteId/:objectUrlName/:componentId`,
  siteComponentGeneralPage: `${MANAGER_URL_WITH_PROJECT_ID}/liegenschaften/:siteId/:objectUrlName/:componentId/general`
} as const;

export const PUBLIC_ROUTES = {
  login: "/login",
  otpConfirm: "/login/code",
  passwordReset: "/password-reset",
  passwordResetConfirm: "/password-reset/confirm",
  setPasswordConfirm: "/set-password/confirm",
  support: "/seiten/support",
  impressum: "/seiten/impressum",
  privacyStatement: "/seiten/datenschutz"
} as const;
